import { InjectionToken } from '@angular/core';
import { UserIdleConfig } from './user-idle.type';

export const USER_IDLE_CONFIG = new InjectionToken<UserIdleConfig>('USER_IDLE_CONFIG');
